import { HostListener, HostBinding, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Styles } from './models/style';
import { SelectorComponent } from './components/selector.component';
import { ESelectorType } from './components/selector.component';

import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Utilities_ShellService } from './Utilities.shell.service';
import { Utilities_OperationService } from './Utilities.operation.service';
import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { Utilities_FlowService } from './Utilities.flow.index';
import { Utilities_FrontendFlowService } from './Utilities.frontend.flow.service';
import { Utilities_ReportService } from './Utilities.report.index';
import { Utilities_LocalizationService } from './Utilities.localization.service';
import { Utilities_transaction_types_dd_ComponentContextService } from './Utilities.transaction_types_dd.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Utilities.frontend.types'
import { $frontendTypes as $types} from './Utilities.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  imports: [
    SharedModule,
  ],
  selector: 'Utilities-transaction_types_dd_single',
  templateUrl: './Utilities.transaction_types_dd_single.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Utilities_transaction_types_dd_singleComponent),
      multi: true
    }
  ]
})
export class Utilities_transaction_types_dd_singleComponent extends BaseComponent implements OnInit, ControlValueAccessor, OnChanges {

  @Input() type?: ESelectorType;
  _disabled = false;
  @Input() get disabled() { 
      return this._disabled 
      ; }
  set disabled(val: any) { this._disabled = val; }

  @Input() placeholder = '';
  @Input() styles: Styles;
  @Input() tooltip = '';

  @Output() displayTextChange: EventEmitter<string> = new EventEmitter();

  @ViewChild(SelectorComponent) selector: SelectorComponent;
  
  @HostBinding('tabIndex') get tabIndex() { return -1; }
  @HostListener('focus')
  focus() {
    this.selector?.focus();
  }

  get isMulti() {
    return false;
  }

  get isSingle() {
    return true;
  }


  inParams: { application_name?: string } = { application_name: null };
  @Input('application_name') set $inParams_application_name(value: any) {
    this.inParams['application_name'] = value;
  }
  get $inParams_application_name(): any {
    return this.inParams['application_name'] ;
  }

  fullTextSearch: string;

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: Utilities_ShellService,
    private $datasources: Utilities_DatasourceService,
    private $flows: Utilities_FlowService,
    private $frontendFlows: Utilities_FrontendFlowService,
    private $reports: Utilities_ReportService,
    private $localization: Utilities_LocalizationService,
    private $operations: Utilities_OperationService,
    private $logger: CleanupLoggerService,
    private $context: Utilities_transaction_types_dd_ComponentContextService,
    private _elementRef: ElementRef
    ) {
    super();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
      return;
    }
  
    // return if none of the actual inParams have changed
    if (!changes['$inParams_application_name']) {
      return;
    }
  
    this.$init();
  }

  
  async $init() {
    this.selector?.init();
  }

  onKeyDown($event: KeyboardEvent) {
    //TODO:KeyDown    
  }

  //ControlValueAccessor
  _innerValue: any;

  onChange: any = () => { };
  onTouch: any = () => { };

  get value(): string | string[] {
    return this._innerValue;
  }

  set value(val: string | string[]) {
    if (this._innerValue !== val) {
      this._innerValue = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  writeValue(value: any): void {
    this._innerValue = value;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }



  displayWithFn(value: any): Promise<string> {
    const promise = new Promise<string>((resolve, reject) => {

      const $selector = this;
      const $utils = this.$utils;

      this.fullTextSearch = null;
      const $fullTextSearch = null;
      this.$datasources.Utilities.ds_transaction_types_dd.getByKeys({
        $keys: [value],
        application_name:  $selector.inParams.application_name ,
        full_text_search:  $selector.fullTextSearch ,
      }).then(result => {
        const found = result.result[0];
        const e: { id?: string, transaction_type?: string } = found ?? {};
        const $option = { entity: e };
         const $entity = e;
        const displayTextResult = found ? ($option.entity.transaction_type) : 'No data to display';
        this.displayTextChange.emit(displayTextResult);
        resolve(displayTextResult);
      });

    });
    return promise;
  }

  optionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {

    const promise = new Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }>((resolve, reject) => {

      const $selector = this;
      const $utils = this.$utils;

      this.fullTextSearch = filterText;
      const $fullTextSearch = filterText;
      this.$datasources.Utilities.ds_transaction_types_dd.getList({
        $top: 25,
        $skip: 0,
        application_name:  $selector.inParams.application_name ,
        full_text_search:  $selector.fullTextSearch ,
      }).then(result => {
        resolve({
          list: result.result.map(item => {
            const $option = { entity: item };
            const $entity = item;
            const $resultOption = { key: null, name: $option.entity.transaction_type, disabled: null };
            $resultOption.key = $option.entity.id;
            return $resultOption;
          }),
          totalCount: result.totalCount,
          top: 25
        });
      });

    });

    return promise;

  }

  //#region private flows
  on_refresh(event = null) {
    return this.on_refreshInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_refreshInternal(
    $selector: Utilities_transaction_types_dd_singleComponent,
  
    $shell: Utilities_ShellService,
    $datasources: Utilities_DatasourceService,
    $flows: Utilities_FlowService,
    $frontendFlows: Utilities_FrontendFlowService,
    $reports: Utilities_ReportService,
    $settings: SettingsValuesService,
    $operations: Utilities_OperationService,
    $utils: UtilsService,
    $context: Utilities_transaction_types_dd_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Utilities_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Utilities', 'transaction_types_dd.on_refresh');
  //O.Arias - 06/20/2024
  
  await $flows.Utilities.list_transaction_types({action: "Refresh"});
  }
  //#endregion private flows
}
